<template lang="pug">
.forest-card
  img(src="~assets/icons/exps/forest.jpg")
</template>
<script>
export default {
  name: 'ForestCard',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.forest-card
  width: 100%
  height: 100%
  img
    width: 100%
    height: 100%
    object-fit: cover
</style>
